module.exports = __webpack_public_path__ + "img/pr-10.477e1ebe.png";